import { createApp } from "vue";
import App from "./App.vue";
import "./styles/app.css";
import "./assets/fonts/source_sans_pro/sourceSansPro.css";
import { HttpClient } from "./http";
import { Vue3Mq } from "vue3-mq";

const filter = JSON.parse(document.getElementById("data").innerText);
const collectionFilter = JSON.parse(
  document.getElementById("collectiondata").innerText
);
const translation = JSON.parse(
  document.getElementById("translation").innerText
);

const appEl = document.querySelector("#flooring-finder-app");

export const apiBaseUrl = appEl.dataset.apiBaseUrl;
export const addToOrderUrl = appEl.dataset.addToOrderUrl;
export const removeFromOrderUrl = appEl.dataset.removeFromOrderUrl;
const orderPageUrl = appEl.dataset.orderPageUrl;
const SearchSettingsId = appEl.dataset.searchSettingsId;
const SettingsId = appEl.dataset.settingsId;
const Id = appEl.dataset.id;

export const httpClient = new HttpClient(apiBaseUrl);

if (!appEl) {
  throw new Error("Missing #flooring-finder-app elememt.");
}

const app = createApp(App);
app.use(Vue3Mq, {
  breakpoints: {
    sm: 0,
    md: 601,
    lg: 768,
    xl: 960,
    xxl: 1200,
  },
});

app.mixin({
  data() {
    return {
      loading: true,
      showNav: false,
      Translation: translation,
      SearchSettingsId: SearchSettingsId,
      SettingsId: SettingsId,
      AddToOrderUrl: addToOrderUrl,
      RemoveFromOrderUrl: removeFromOrderUrl,
      OrderPageUrl: orderPageUrl,
      Id: Id,
      Filter: filter,
      CollectionFilter: collectionFilter,
      Page: null,
      PageSize: null,
      TotalPage: null,
      TotalProductCount: null,
      CollectionResults: [],
      TotalCollectionCount: 0,
      ProductResults: [],
      error: null,
      errorHeadline: null,
      checkedFilters: [],
      openDetailsIndex: null,
    };
  },
  computed: {
    imageSrcOrigin() {
      return process.env.NODE_ENV === "development"
        ? "https://www.nora.com"
        : window.location.origin;
    },
  },
});

app.mount(appEl);
